/**
 * Get vote status text according to how many players have voted
 *
 * Assume that voters cast exactly 1 of each vote type. Therefore
 * divide by the number of enabled vote types to get the count of
 * people who've voted.
 *
 * @param totalVoteCount The total number of votes that've been cast so far
 * @param voteTypeCount The number of currently active vote types for the team
 */
export const voteCountText = (
  totalVoteCount: number,
  voteTypeCount: number,
) => {
  const voterCount = Math.floor(totalVoteCount / voteTypeCount);

  if (voterCount === 0) {
    return `You're the first player to vote`;
  }

  if (voterCount === 1) {
    return `One player has voted so far.`;
  }

  return `${
    totalVoteCount % voteTypeCount === 0 ? '' : 'About '
  }${voterCount} players have voted so far.`;
};
